export const primaryColor = "#FF5829";
export const lightColor = "#FF8B56";
export const darkColor = "#C41E00";
